import { useRef, useState } from "react";

import { useNavigate } from "react-router-dom";

import {
	Avatar,
	Box,
	Button,
	Divider,
	Hidden,
	Popover,
	Typography,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import ExpandMoreTwoToneIcon from "@mui/icons-material/ExpandMoreTwoTone";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { resetState } from "../../../../redux/services/authSlice";

const UserBoxButton = styled(Button)(
	({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
`
);

const MenuUserBox = styled(Box)(
	({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
	({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
	({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`
);

function HeaderUserbox() {
	const navigate = useNavigate();
	const gdata = useSelector((state: RootState) => state.gdata);

	const user = {
		name: "Catherine Pike",
		avatar: "/static/images/avatars/1.jpg",
		jobtitle: "Project Manager",
	};

	const ref = useRef<any>(null);
	const [isOpen, setOpen] = useState<boolean>(false);

	const handleOpen = (): void => {
		setOpen(true);
	};

	const handleClose = (): void => {
		setOpen(false);
	};

	const dispatch = useDispatch();
	const handleLogout = () => {
		dispatch(resetState());

		navigate("/");
	};

	const handleProfile = () => {
		handleClose();
		navigate("/profile");
	};

	const handlePassword = () => {
		handleClose();
		navigate("/password");
	};

	return (
		<>
			<UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
				<Avatar variant="rounded" alt={gdata.username} src={user.avatar} />
				<Hidden mdDown>
					<UserBoxText>
						<UserBoxLabel variant="body1">{gdata.username}</UserBoxLabel>
					</UserBoxText>
				</Hidden>
				<Hidden smDown>
					<ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
				</Hidden>
			</UserBoxButton>
			<Popover
				anchorEl={ref.current}
				onClose={handleClose}
				open={isOpen}
				anchorOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
			>
				<MenuUserBox sx={{ minWidth: 210 }} display="flex">
					<Avatar variant="rounded" alt={gdata.username} src={user.avatar} />
					<UserBoxText>
						<UserBoxLabel variant="body1">{gdata.username}</UserBoxLabel>
					</UserBoxText>
				</MenuUserBox>
				<Divider />
				<Box sx={{ m: 1 }}>
					<Button color="primary" fullWidth onClick={handleProfile}>
						<AccountBoxIcon sx={{ mr: 1 }} />
						Profile
					</Button>
				</Box>
				<Divider />
				<Box sx={{ m: 1 }}>
					<Button color="primary" fullWidth onClick={handlePassword}>
						<LockIcon sx={{ mr: 1 }} />
						Password
					</Button>
				</Box>
				<Divider />
				<Box sx={{ m: 1 }}>
					<Button color="primary" fullWidth onClick={handleLogout}>
						<LockOpenTwoToneIcon sx={{ mr: 1 }} />
						Sign out
					</Button>
				</Box>
			</Popover>
		</>
	);
}

export default HeaderUserbox;
